<template>
    <div class="uk-container">

        <div class="uk-width-1-2@l uk-text-center uk-text-small uk-margin-auto">
            <el-upload
              class="upload-demo"
              ref="upload"
              :file-list="fileList"
              action='/connect/api/upload/'
              :auto-upload="true"
              multiple
              name="photo[]"
              :show-file-list="false"
              :on-success="handleSuccess"
              :before-upload="startUpload"
              >
              <el-button slot="trigger" size="medium" type="primary">アップロードする写真を選択</el-button>
              <div class="el-upload__tip" slot="tip"></div>
            </el-upload>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { Loading } from 'element-ui';

export default {
    name: 'upload',
    data: function () {
        return {
            fileList: [],
            uploadCounter: 0,
            uploading: false,
            loadingInstance: {}
        }
    },
    methods: {
        handleSuccess (response, file, fileList) {
            this.uploadCounter++
            if (fileList.length == this.uploadCounter) {
                this.loadingInstance.close()
                this.uploading = false
                this.$notify({
                    title: 'Success',
                    message: '写真のアップロードが完了しました',
                    type: 'success'
                });
                this.$store.dispatch('updateFullList', this.$config.common.apiPath)
            }
        },
        startUpload (file) {
            if (!this.uploading) {
                this.loadingInstance = Loading.service({ fullscreen: true });
                this.uploading = true
            }
        }
    },
    mounted () {
    }
}
</script>

<style>
</style>

